import DashboardLayout from "@/views/LayoutView/DashboardLayout.vue";

import MemberPaymentHistory from "@/views/PaymentView/MemberPaymentHistory.vue";
import MemberFeePayment from "@/views/PaymentView/MemberFeePayment.vue";
import MemberDonation from "@/views/PaymentView/MemberDonation.vue";

import Success from "@/components/toss/Success.vue";
import Completed from "@/components/toss/Completed.vue";
import Fail from "@/components/toss/Fail.vue";

import PaypalSuccess from "@/components/paypal/PaypalSuccess.vue";
import PaypalCompleted from "@/components/paypal/PaypalCompleted.vue";
import PaypalFail from "@/components/paypal/PaypalFail.vue";

const paymentsMenu = {
  path: "/payments",
  component: DashboardLayout,
  redirect: "/payments",
  name: "Payments",
  children: [
    {
      path: "",
      name: "payment_history",
      components: { default: MemberPaymentHistory },
      meta: { requiresAuth: true, title: "topnav.payment_history" },
    },
    {
      path: "fee",
      name: "payment_fee",
      components: { default: MemberFeePayment },
      meta: { requiresAuth: true, title: "topnav.payment_fee" },
    },
    {
      path: "donation",
      name: "payment_donation",
      components: { default: MemberDonation },
      meta: { requiresAuth: true, title: "topnav.payment_donation" },
    },
    {
      path: "toss/success",
      components: { default: Success },
      meta: { requiresAuth: true, title: "" },
    },
    {
      path: "toss/completed",
      components: { default: Completed },
      meta: { requiresAuth: true, title: "" },
    },
    {
      path: "toss/fail",
      components: { default: Fail },
      meta: { requiresAuth: true, title: "" },
    },
    {
      path: "paypal/success",
      components: { default: PaypalSuccess },
      meta: { requiresAuth: true, title: "" },
    },
    {
      path: "paypal/completed",
      components: { default: PaypalCompleted },
      meta: { requiresAuth: true, title: "" },
    },
    {
      path: "paypal/fail",
      components: { default: PaypalFail },
      meta: { requiresAuth: true, title: "" },
    },
  ],
};

export default paymentsMenu;
